/**
 * Turning a fee type off (or archiving it) also removes it from classes that
 * no longer run (inactive or ended; templates keep it). The API returns
 * those classes so we can say what happened instead of doing it silently.
 */
import type { ClassRef } from "@/types/feeType";

/** Shared copy for the Activate/Delete explanations (detail + list pages). */
export const FEE_TYPE_TURN_OFF_NOTE =
  "Activate turns the fee type back on, but classes it was removed from " +
  "won't charge it again until you add it back. Templates keep it.";

export function turnedOffMessage(
  verb: "turned off" | "archived",
  retired: ClassRef[] | null | undefined,
): string {
  const list = retired ?? [];
  if (list.length === 0) return `Fee type ${verb}.`;
  const names = list.slice(0, 3).map((c) => c.name);
  const more = list.length > 3 ? ` and ${list.length - 3} more` : "";
  const noun = list.length === 1 ? "class" : "classes";
  return (
    `Fee type ${verb}. Also removed from ${list.length} ${noun} that no ` +
    `longer run: ${names.join(", ")}${more}.`
  );
}
